<template>
  <div>
    <footer-pc v-if="isPc()"/>
    <footer-mobile v-else/>
  </div>
</template>

<script>
import util from '@/assets/js/util'
import FooterPc from './FooterPc.vue'
import FooterMobile from './FooterMobile.vue'

export default {
  components: {
    FooterPc,
    FooterMobile,
  },
  data() {
    return {
      scrollY: 0,
    }
  },

  methods: {
    isPc() {
      return util.isPc()
    },
  },
}
</script>



// WEBPACK FOOTER //
// Footer.vue?1809c793